import Checkbox from "@components/Checkbox";
import { FaMinus } from "react-icons/fa";

const SelectAll = ({
  label,
  all,
  selectChange,
  chosen_items,
  clearSelectedItems,
}) => {
  return (
    <Checkbox
      label={label || "Select All"}
      name='checkbox'
      checked={chosen_items?.length > 0 ? true : false}
      onChange={
        // chosen_items?.length > 0 && all.length !== chosen_items.length - 1
        //   ? () => clearSelectedItems()
        () => selectChange()
      }
      icon={
        chosen_items?.length === all.length ? null : <FaMinus color='white' />
      }
    />
  );
};

export default SelectAll;
